import { appBranding } from '@/lib/features'

let currentRoutePath = window.location.pathname || ''

/**
 * @param {string} path
 */
export function setCurrentRoutePath(path = '') {
  currentRoutePath = path
}

/**
 * @returns {string}
 */
export function getCurrentRoutePath() {
  return currentRoutePath
}

/**
 * @param {string} routePath
 * @returns {string[]}
 */
export function getActiveOverrideNamespaces(routePath = '') {
  const activeOverrideNamespaces = []

  if (appBranding?.config?.platform === 'bottimmo') {
    activeOverrideNamespaces.push('bottimmo')
  } else if (appBranding?.config?.platform === 'smg') {
    activeOverrideNamespaces.push('bottimmo', 'smg')
  } else if (appBranding?.config?.platform === 'falc') {
    activeOverrideNamespaces.push('bottimmo', 'falc')
  } else if (appBranding?.config?.platform === 'remax') {
    activeOverrideNamespaces.push('bottimmo', 'remax')
  }

  if (routePath.startsWith('/master')) {
    activeOverrideNamespaces.push('master')
  }

  return activeOverrideNamespaces
}
